import MolhamModalOffcanvas from "components/MolhamModalOffCanvas";
import useMobile from "customHooks/useMobile";
import useTranslation from "next-translate/useTranslation";
import MolhamButton from "../MolhamButton";

type Props = {
  handleCloseDeleteCommentModal: () => void;
  showDeleteCommentModal: boolean;
  isLoading: boolean;
  onDeleteCommentSubmit: () => void;
  commentDetails: string;
};
const DeleteCommentModal = ({
  handleCloseDeleteCommentModal,
  showDeleteCommentModal,
  isLoading,
  onDeleteCommentSubmit,
  commentDetails,
}: Props) => {
  const { t } = useTranslation("common");
  const isMobile = useMobile("md");

  return (
    <MolhamModalOffcanvas
      onHide={handleCloseDeleteCommentModal}
      show={showDeleteCommentModal}
    >
      <label className={`mb-3 fs-${isMobile ? "6" : "lg"}`}>
        {t(`delete_comment_description`)}
      </label>
      <div className="rounded-sm bg-secondary mb-3 p-2">
        <span className="fs-6">{commentDetails}</span>
      </div>
      <div className="d-flex align-items-center justify-content-between">
        <MolhamButton
          id="comment-delete-btn"
          label={t(`delete_comment`)}
          isLoading={isLoading}
          startIcon="fe-trash fs-lg"
          variant="danger"
          onClick={onDeleteCommentSubmit}
          className="w-100 mt-1 mb-3 mb-lg-1"
        />
      </div>
    </MolhamModalOffcanvas>
  );
};

export default DeleteCommentModal;
